export default __webpack_public_path__ + "static/media/Hotel.236fffd7.png";